import { PublicClientApplication, AuthenticationResult, AccountInfo, RedirectRequest, PopupRequest, EndSessionRequest } from "@azure/msal-browser";
import { MsalConfig } from "./azure-authentication-config";

// Source
import ControllerAlert from "../controller/Alert";
import * as HelperSrc from "../HelperSrc";
import * as ApiAuthentication from "../api/Authentication";
import * as ModelHelperSrc from "../model/HelperSrc";
import * as ModelAuthentication from "../model/Authentication";

export default class AzureAuthenticationContext {
    private controllerAlert: ControllerAlert;

    private loginRedirectRequest: RedirectRequest;
    private loginRequest: PopupRequest;

    constructor(controllerAlert: ControllerAlert) {
        this.controllerAlert = controllerAlert;

        this.loginRequest = {
            scopes: ["User.Read"]
        };
        this.loginRedirectRequest = {
            ...this.loginRequest,
            redirectStartPage: window.location.href
        };
    }

    login(signInType: string, callback: ModelHelperSrc.IapiCallback): void {
        ApiAuthentication.activeDir((response) => {
            if (response instanceof Error || response.message.error) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response.message);
                } else {
                    this.controllerAlert.show("error", response.message.error, false);
                }

                return;
            }

            const result = response.data.result as unknown as ModelAuthentication.IresponseActiveDir;

            const authAd = {
                clientId: result.ad_client,
                authority: `${HelperSrc.URL_AD_LOGIN}/${result.ad_tenant}`
            };

            HelperSrc.writeCookie("auth_ad", authAd);

            MsalConfig.auth.clientId = authAd.clientId;
            MsalConfig.auth.authority = authAd.authority;

            const myMsalObj: PublicClientApplication = new PublicClientApplication(MsalConfig);

            myMsalObj.initialize();

            if (signInType === "loginPopup") {
                myMsalObj
                    .loginPopup(this.loginRequest)
                    .then((responseAuthentication: AuthenticationResult) => {
                        const accountInfo = {
                            ...responseAuthentication.account
                        };

                        if (responseAuthentication.expiresOn) {
                            HelperSrc.writeCookie("account_info", accountInfo, responseAuthentication.expiresOn.toISOString());
                        }

                        if (accountInfo.username) {
                            ApiAuthentication.loginAd(responseAuthentication.idToken, accountInfo.username, callback);
                        }
                    })
                    .catch((error: Error) => {
                        callback(error);
                    });
            } else if (signInType === "loginRedirect") {
                myMsalObj
                    .loginRedirect(this.loginRedirectRequest)
                    .then(() => {
                        //...
                    })
                    .catch(() => {
                        //...
                    });
            }
        });
    }

    logout(): Promise<void> | null {
        let result: Promise<void> | null = null;

        const cookieAccountInfo = HelperSrc.readCookie<AccountInfo>("account_info");
        const cookieAuthAd = HelperSrc.readCookie<ModelAuthentication.IactiveDir>("auth_ad");

        if (cookieAccountInfo && cookieAuthAd) {
            MsalConfig.auth.clientId = cookieAuthAd ? cookieAuthAd.clientId : "";
            MsalConfig.auth.authority = cookieAuthAd ? cookieAuthAd.authority : "";

            const logOutRequest: EndSessionRequest = {
                account: cookieAccountInfo,
                postLogoutRedirectUri: HelperSrc.URL_AD_REDIRECT,
                onRedirectNavigate: () => {
                    HelperSrc.removeCookie("auth_ad");
                    HelperSrc.removeCookie("account_info");

                    return true;
                }
            };

            const myMsalObj: PublicClientApplication = new PublicClientApplication(MsalConfig);

            myMsalObj.initialize();

            result = myMsalObj.logoutRedirect(logOutRequest);
        }

        return result;
    }
}
